import { updateActionErrors } from "./updateErrors";
import {
    getSettingsQuery, updateSettingsMutation
} from "../../api/graphql/queries/settings";
import graphqlClient from "../../api/axios_interceptor";
import { FETCH_SETTINGS, UPDATE_SETTINGS } from "../actions/actionTypes";
import { FormDataRestClient } from '../../api/rest_interceptor';
import { GRAPHQL_API } from '../../api/graphql/endpoint';



export const getSettingsFormData = (query, logo, letterhead) => {
    const formData = new FormData();
    formData.append("operations", JSON.stringify({
            "query": query,
            "variables": {"logo" : null, "letterhead" : null},
        })
    )
    if (logo){
        formData.append("map", JSON.stringify({"0": ["variables.logo"]}));
        formData.append("0", logo);
    }
    if (letterhead){
        formData.append("map", JSON.stringify({"1": ["variables.letterhead"]}));
        formData.append("1", logo);
    }

    return formData;
}

export const parseSettings = (settings) => {
    let newSettings = {
        companyName: settings.companyName || "",
        companyShortName: settings.companyShortName || "",
        accountType: settings.customerAccount.accountType || "",
        includeInMessages: settings.includeInMessages || false,
        address: settings.address || "",
        invoiceTitle: settings.invoiceTitle ?? "",
        invoiceFootnote: settings.invoiceFootnote ?? "",
        logoFileId: settings.logo? settings.logo.id : "",
        logoFileName: settings.logo? settings.logo.file : "",
        letteheadFileId: settings.letterhead? settings.letterhead.id : "",
        letteheadFileName: settings.letterhead? settings.letterhead.file : ""
    };
    let defaultMpesa = settings.defaultMpesaShortcode || {};
    const mpesa = {
        defaultAccountNumber: defaultMpesa.defaultAccountNumber || "",
        shortcodeType: defaultMpesa.shortcodeType || "PAYBILL",
        shortcode: defaultMpesa.shortcode || "",
        tillNumber: defaultMpesa.tillNumber || "",
        validatePayments: defaultMpesa.validatePayments ?? true
    }

    newSettings["mpesa"] = mpesa;

    const automatedTasks = {
        autoGenerateRentInvoices: settings.customerAccount.autoGenerateRentInvoices || false,
        autoGenerateOtherRecurringInvoices: settings.customerAccount.autoGenerateOtherRecurringInvoices || false,
        alertLandlordNewTenant: settings.customerAccount.alertLandlordNewTenant || false,
        tenantPaymentReminderDates : Array.isArray(settings.customerAccount.tenantPaymentReminderDates) ? settings.customerAccount.tenantPaymentReminderDates : [],
        leaseSmsAlertDays: Array.isArray(settings.customerAccount.leaseSmsAlertDays) ? settings.customerAccount.leaseSmsAlertDays : [],
        messageTypes: settings.customerAccount.messageTypes || []
    }

    newSettings["automatedTasks"] = automatedTasks;

    return newSettings

}

export const fetchSettingsMiddleware = async (action) => {
    try{
        const payload = action.payload;
        await graphqlClient({
            data: {
                query: getSettingsQuery(action.payload)
            }
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
            } else {
                action = ({
                    ...action,
                    payload: {
                        ...payload,
                        settings: parseSettings(queryResult.data.data.generalSettings)
                    }
                });
            }
        })
    }catch(error){
        console.log(error);
        action = updateActionErrors(action, error);
    }
    return action;
}


export const updateSettingsMiddleware = async (action) => {
    try{
        const payload = action.payload;
        const query = updateSettingsMutation({...payload});
        const formData = getSettingsFormData(query, payload.logo, payload.letterhead);
        await FormDataRestClient.post(
            GRAPHQL_API, formData
        ).then( (queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
            } else if(queryResult.data.data.updateSettings.error){
                action = updateActionErrors(action,queryResult.data.data.updateSettings.error.message);
                action = {
                    errorCode: queryResult.data.data.updateSettings.error.code,
                    ...action
                }
            } else {
                action = ({
                    ...action,
                    payload: {
                        ...payload,
                        settings: parseSettings(queryResult.data.data.updateSettings.company)
                    }
                });
            }
        })

    }catch(error){
        console.log(error);
        action = updateActionErrors(action, error);
    }
    return action;
}

export const settingsMiddleware = storeAPI => next => async action => {
    switch(action.type){
        case FETCH_SETTINGS:
            action = await fetchSettingsMiddleware(action);
            break;
        case UPDATE_SETTINGS:
            action = await updateSettingsMiddleware(action);
            break;
    }
    return next(action);
}